import SkapaDualButton, { type DualButtonProps } from "@ingka/dual-button";

export const DualButton = (props: DualButtonProps) => {
  return <SkapaDualButton prefix="saleslead__" {...props} />;
};
